export const regexp = '\\p{L}'
